import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import HomeIcon from '@material-ui/icons/Home';

// Custom dashboard mounted at the index route. The title + icon make it appear
// in the sidebar automatically (NavItemBlueprint was folded into PageBlueprint).
const homePage = PageBlueprint.make({
  name: 'home',
  params: {
    path: '/',
    title: 'Home',
    icon: <HomeIcon />,
    loader: () => import('./HomePage').then(m => <m.HomePage />),
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [homePage],
});
